import { CockpitDocumentsAndLinks } from './CockpitDocumentsAndLinks'
import type { TDocumentType } from './types'

interface ICockpitDocumentsAndLinksCollapsedProps {
  partnerId?: string
  onExpand: () => void
  onViewDocuments: (type: TDocumentType) => void
  isManagerCockpitMode?: boolean
}

export const CockpitDocumentsAndLinksCollapsed = ({
  partnerId,
  onExpand,
  onViewDocuments,
  isManagerCockpitMode,
}: ICockpitDocumentsAndLinksCollapsedProps) => (
  <CockpitDocumentsAndLinks
    expanded={false}
    partnerId={partnerId}
    onExpand={onExpand}
    onViewDocuments={onViewDocuments}
    isManagerCockpitMode={isManagerCockpitMode}
  />
)

CockpitDocumentsAndLinksCollapsed.displayName = 'CockpitDocumentsAndLinksCollapsed'
